<template>
  <step-display :current-step="NaN" background-image="Reem/protectedBG.svg" mobile-background-image="empty.svg">
    <account-is-protected />
  </step-display>
</template>

<script>
import StepDisplay from "@/components/global/StepDisplay";
import AccountIsProtected from "@/components/steps/AccountProtected";

export default {
  name: "AccountProtected",
  components: {
    StepDisplay,
    AccountIsProtected
  }
}
</script>

<style lang="scss" scoped>

</style>